import { useRouter } from 'next/router'
import Image from 'next/image'

import {
  Dialog,
  DialogCancel,
  DialogContent,
  DialogOverlay,
} from '@wartek-id/dialog-v1'
import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text-v1'

import EligibilityGuard from 'app/PemetaanKompetensiPage/components/EligibilityGuard'
import Main from 'app/PemetaanKompetensiPage/pages/ProfileRevamp/Main'
import { checkDateTimeServer } from 'app/PemetaanKompetensiPage/utils'
import RefleksiKompetensiErrorBoundary from 'app/PemetaanKompetensiPage/components/RefleksiKompetensiErrorBoundary'
import { PERIOD_QUERY_PARAM } from 'app/PemetaanKompetensiPage/components/AsesmenRefleksi/PeriodGuardChecker'

export async function getServerSideProps() {
  const currentDateTimeServer = await checkDateTimeServer()

  return {
    props: {
      currentDateTimeServer,
      pageTitle: 'Refleksi Kompetensi',
    },
  }
}

const PageKompetensiProfil = ({ currentDateTimeServer }) => {
  const router = useRouter()

  const isPeriodGuardOpen = !!router.query[PERIOD_QUERY_PARAM]
  const handleClosePeriodGuard = () =>
    router.replace('/refleksi-kompetensi', undefined, {
      shallow: true,
    })

  return (
    <>
      <RefleksiKompetensiErrorBoundary withHeader>
        <EligibilityGuard currentDateTimeServer={currentDateTimeServer}>
          <Main currentDateTimeServer={currentDateTimeServer} />
        </EligibilityGuard>
      </RefleksiKompetensiErrorBoundary>

      <Dialog
        isOpen={isPeriodGuardOpen}
        onClose={handleClosePeriodGuard}
        size="sm"
      >
        <DialogOverlay />
        <DialogContent className="p-4">
          <div className="flex justify-center mb-4">
            <Image
              alt=""
              width="120"
              height="120"
              src="/illustrations/img-files-document-failed.png"
            />
          </div>
          <Text variant="heading-sm" className="mb-1">
            Periode refleksi sudah berakhir
          </Text>
          <Text className="mb-4">
            Refleksi yang belum dikumpulkan otomatis terhapus. Ikuti periode
            refleksi berikutnya nanti, ya.
          </Text>

          <DialogCancel as={Button} onClick={handleClosePeriodGuard} fullWidth>
            Saya mengerti
          </DialogCancel>
        </DialogContent>
      </Dialog>
    </>
  )
}

PageKompetensiProfil.layoutOpts = {
  className: 'text-default bg-gray-10 !h-full min-h-screen !max-w-full',
}

export default PageKompetensiProfil
